export * as carouselBuild from './advanced/carousel/carousel.build';
export * as carouselTemplateBuild from './advanced/carousel/carousel-template/carousel-template.build';
export * as loginBuild from './advanced/login/login.build';
export * as marqueeBuild from './advanced/marquee/marquee.build';
export * as anchorBuild from './basic/default/anchor/anchor.build';
export * as audioBuild from './basic/default/audio/audio.build';
export * as htmlBuild from './basic/default/html/html.build';
export * as iconBuild from './basic/default/icon/icon.build';
export * as iframeBuild from './basic/default/iframe/iframe.build';
export * as labelBuild from './basic/default/label/label.build';
export * as pictureBuild from './basic/default/picture/picture.build';
export * as spinnerBuild from './basic/default/spinner/spinner.build';
export * as progressBarBuild from './basic/progress/progress-bar/progress-bar.build';
export * as progressCircleBuild from './basic/progress/progress-circle/progress-circle.build';
export * as rteBuild from './basic/rich-text-editor/rich-text-editor.build';
export * as searchBuild from './basic/search/search.build';
export * as treeBuild from './basic/tree/tree.build';
export * as cardBuild from './data/card/card.build';
export * as cardContentBuild from './data/card/card-content/card-content.build';
export * as cardActionsBuild from './data/card/card-actions/card-actions.build';
export * as cardFooterBuild from './data/card/card-footer/card-footer.build';
export * as chartBuild from './chart/chart.build';
export * as accordionBuild from './containers/accordion/accordion.build';
export * as accordionPaneBuild from './containers/accordion/accordion-pane/accordion-pane.build';
export * as containerBuild from './containers/container.build';
export * as lgcolBuild from './containers/layout-grid/layout-grid-column/layout-grid-column.build';
export * as lgrowBuild from './containers/layout-grid/layout-grid-row/layout-grid-row.build';
export * as lgBuild from './containers/layout-grid/layout-grid.build';
export * as panelBuild from './containers/panel/panel.build';
export * as segControlBuild from './containers/segmented-control/segmented-control.build';
export * as segContentBuild from './containers/segmented-control/segment-content/segment-content.build';
export * as repeatTemplateBuild from './containers/repeat-template.build';
export * as tabsBuild from './containers/tabs/tabs.build';
export * as tabPaneBuild from './containers/tabs/tab-pane/tab-pane.build';
export * as tileBuild from './containers/tile/tile.build';
export * as wizardBuild from './containers/wizard/wizard.build';
export * as wizardStepBuild from './containers/wizard/wizard-step/wizard-step.build';
export * as barcodeScannerBuild from './device/barcode-scanner/barcode-scanner.build';
export * as cameraBuild from './device/camera/camera.build';
export * as alertDlgBuild from './dialogs/alert-dialog/alert-dialog.build';
export * as confirmDlgBuild from './dialogs/confirm-dialog/confirm-dialog.build';
export * as dlgFooterBuild from './dialogs/base/dialog-footer/dialog-footer.build';
export * as dlgBuild from './dialogs/design-dialog/dialog.build';
export * as iframeDlgBuild from './dialogs/iframe-dialog/iframe-dialog.build';
export * as loginDlgBuild from './dialogs/login-dialog/login-dialog.build';
export * as partialDlgBuild from './dialogs/partial-dialog/partial-dialog.build';
export * as formFieldBuild from './data/form/form-field/form-field.build';
export * as formActionBuild from './data/form/form-action/form-action.build';
export * as formBuild from './data/form/form.build';
export * as calendarBuild from './input/calendar/calendar.build';
export * as chipsBuild from './input/chips/chips.build';
export * as colorPickerBuild from './input/color-picker/color-picker.build';
export * as currencyBuild from './input/currency/currency.build';
export * as buttonGroupBuild from './input/default/button-group/button-group.build';
export * as buttonBuild from './input/default/button/button.build';
export * as checkboxBuild from './input/default/checkbox/checkbox.build';
export * as checkboxSetBuild from './input/default/checkboxset/checkboxset.build';
export * as compositeBuild from './input/default/composite/composite.build';
export * as numberBuild from './input/default/number/number.build';
export * as radiosetBuild from './input/default/radioset/radioset.build';
export * as selectBuild from './input/default/select/select.build';
export * as switchBuild from './input/default/switch/switch.build';
export * as textBuild from './input/default/text/text.build';
export * as textAreaBuild from './input/default/textarea/textarea.build';
export * as dateTimeBuild from './input/epoch/date-time/date-time.build';
export * as dateBuild from './input/epoch/date/date.build';
export * as timeBuild from './input/epoch/time/time.build';
export * as fileUploadBuild from './input/file-upload/file-upload.build';
export * as ratingBuild from './input/rating/rating.build';
export * as sliderBuild from './input/slider/slider.build';
export * as mediaListBuild from './data/media-list/media-list.build';
export * as mediaListItemBuild from './data/media-list/media-list-item/media-list-item.build';
export * as listBuild from './data/list/list.build';
export * as liveTableBuild from './data/live-table/live-table.build';
export * as messageBuild from './message/message.build';
export * as breadcrumbBuild from './navigation/breadcrumb/breadcrumb.build';
export * as menuBuild from './navigation/menu/menu.build';
export * as navItemBuild from './navigation/nav/nav-item/nav-item.build';
export * as navBuild from './navigation/nav/nav.build';
export * as navbarBuild from './navigation/navbar/navbar.build';
export * as popoverBuild from './navigation/popover/popover.build';
export * as pageBuild from './page/page.build';
export * as paginationBuild from './data/pagination/pagination.build';
export * as contentBuild from './page/content/content.build';
export * as footerBuild from './page/footer/footer.build';
export * as headerBuild from './page/header/header.build';
export * as leftPanelBuild from './page/left-panel/left-panel.build';
export * as mobileNavbarBuild from './page/mobile-navbar/mobile-navbar.build';
export * as rightPanelBuild from './page/right-panel/right-panel.build';
export * as pageContentBuild from './page/page-content/page-content.build';
export * as tabBarBuild from './page/tab-bar/tab-bar.build';
export * as topNavBuild from './page/top-nav/top-nav.build';
export * as partialBuild from './partial/partial.build';
export * as partialParamBuild from './partial-param/partial-param.build';
export * as prefabBuild from './prefab/prefab.build';
export * as prefabContainerBuild from './prefab/prefab-container/prefab-container.build';
export * as tableActionBuild from './data/table/table-action/table-action.build';
export * as tableColumnGroupBuild from './data/table/table-column-group/table-column-group.build';
export * as tableColumnBuild from './data/table/table-column/table-column.build';
export * as tableRowBuild from './data/table/table-row/table-row.build';
export * as tableRowActionBuild from './data/table/table-row-action/table-row-action.build';
export * as tableBuild from './data/table/table.build';
export * as videoBuild from './basic/default/video/video.build';

export * from '@wm/transpiler';

export const initComponentsBuildTask = () => {};
